import { isHighlightWindowOpen } from './dateUtils';

export const ROLES = {
  MANAGER: 'manager',
  SPOC: 'spoc',
  TEACHER: 'teacher',
  STUDENT: 'student',
  VIEWER: 'viewer'
};

/**
 * Build a single permissions object from the /api/auth/user response.
 * @param {string} role - 'manager' | 'spoc' | 'viewer'
 * @param {string[]} spocMous - MoU prefixes assigned to this SPOC
 */
export function buildPermissions(role, spocMous = []) {
  const resolvedRole = role || ROLES.VIEWER;
  const isManager = resolvedRole === ROLES.MANAGER;
  const isSpoc = resolvedRole === ROLES.SPOC;
  const isViewer = resolvedRole === ROLES.VIEWER || resolvedRole === ROLES.STUDENT || resolvedRole === ROLES.TEACHER;

  return {
    role: resolvedRole,
    spocMous: [...spocMous],
    can: {
      viewDashboard: isManager || isSpoc || (isViewer && isHighlightWindowOpen()),
      uploadMou: isManager,
      editMou: (prefix) => isManager,
      deleteMou: (prefix) => isManager,
      manageActivities: (prefix) => isManager || (isSpoc && spocMous.includes(prefix)),
      viewKpis: (prefix) => isManager,
      viewReports: (prefix) => isManager || (isSpoc && spocMous.includes(prefix)),
      seeMouInList: (prefix) => true,
      assignSpoc: (prefix) => isManager,
    }
  };
}
